export default "__VITE_ASSET__2aabf618__"